import { useState } from "react";
import api from "../lib/api";
import { toast } from "sonner";
import { Mail } from "lucide-react";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const subscribe = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      await api.post("/newsletter/subscribe", { email });
      toast.success("Subscribed! Watch your inbox for apprenticeship alerts.");
      setEmail("");
    } catch {
      toast.error("Something went wrong. Try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <footer className="border-t border-zinc-800 mt-24 bg-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2 mb-4">
            <div className="w-8 h-8 bg-yellow-500 flex items-center justify-center">
              <div className="w-3 h-3 bg-black"></div>
            </div>
            <span className="font-display text-xl uppercase">
              Discover<span className="text-yellow-500">Apprenticeship</span>
            </span>
          </div>
          <p className="text-zinc-500 text-sm max-w-md leading-relaxed">
            Powered by public data from apprenticeship.gov. Find Registered Apprenticeship
            opportunities across America — earn while you learn.
          </p>
        </div>

        <div>
          <h4 className="font-display uppercase tracking-widest text-yellow-500 text-sm mb-4">Explore</h4>
          <ul className="space-y-2 text-sm text-zinc-400">
            <li><a href="/jobs">Job Search</a></li>
            <li><a href="/employers">Employer Directory</a></li>
            <li><a href="/industries">Industries</a></li>
            <li><a href="/ai-match">AI Match</a></li>
          </ul>
        </div>

        <div>
          <h4 className="font-display uppercase tracking-widest text-yellow-500 text-sm mb-4">Job Alerts</h4>
          <form onSubmit={subscribe} className="flex flex-col gap-2">
            <div className="flex border border-zinc-800 focus-within:border-yellow-500 transition-colors">
              <input
                data-testid="newsletter-input"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@email.com"
                className="flex-1 bg-transparent px-3 py-2 text-sm text-white focus:outline-none"
              />
              <button
                data-testid="newsletter-submit"
                disabled={loading}
                className="bg-yellow-500 text-black px-3 hover:bg-yellow-400 transition disabled:opacity-50"
              >
                <Mail size={16} />
              </button>
            </div>
            <p className="text-xs text-zinc-600">Weekly opportunities near you.</p>
          </form>
        </div>
      </div>
      <div className="border-t border-zinc-800 py-6 text-center text-xs text-zinc-600">
        &copy; 2026 DiscoverApprenticeship.com &middot; Data sourced from public U.S. Department of Labor systems.
      </div>
    </footer>
  );
}
